export const hideSideNav = (
  pathname: string,
  restrictedSideBarUrl: string[],
) => {
  let hide = false;
  restrictedSideBarUrl.forEach((url) => {
    if (pathname.startsWith(url)) {
      hide = true;
      return;
    }
  });

  return hide;
};
